
import React from 'react';
import ReactDOM from 'react-dom';
import {Header } from 'rsuite';

class CUSTHeader extends React.Component {
     render() {
         return <Header className="header_cus">
             <img className="image_logo mt-1 mb-1" src={process.env.PUBLIC_URL + '/images/logo.png'} alt="Stickman" width="24" ></img>
             {/* <hr className="line1 mt-1 mb-1"></hr> */}

         </Header>;
  }
    
   
}

export default CUSTHeader;